import { tv } from 'tailwind-variants'

export const replyMessageBubbleVariants = tv({
  slots: {
    base: 'flex flex-row w-full h-full p-mili rounded-tl-mili rounded-tr-mili mb-mili items-center'
  },
  variants: {
    source: {
      CLIENT: {
        base: 'rounded-b-mili self-start bg-[#d0cdca] border-l-[5px] border-success-medium'
      },
      PRODUCT: {
        base: 'rounded-b-mili self-end bg-[#9a958f] border-l-[5px] border-primary-medium '
      }
    }
  }
})
